import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { sendConfirmationConnection } from "shared/outbox/selectors"
import { Icon } from "quorumdesign"

import * as S from "app/static/frontend/outbox/components/Alerts/style"
import * as designConstants from "app/static/frontend/design-constants"

const SendConfirmation = (props) => (
    <S.SendConfirmationWrapper>
        <div>
            <span>
                <strong>Subject Line:</strong> {props.subject}
            </span>
        </div>
        {props.isScheduled && (
            <div>
                <Icon icon="clock" iconFamily="far" color={designConstants.QuorumBlue} />
                <span>
                    Your email is scheduled for <strong>{props.scheduledSendMoment.format("MM/DD/YYYY")}</strong>
                    {" at "}
                    <strong>{props.scheduledSendMoment.format("h:mmA")}</strong>
                </span>
            </div>
        )}
        <div>
            <Icon icon="paper-plane" iconFamily="fas" color={designConstants.QuorumBlue} />
            Sender Name & Email: {props.fromName} | {props.fromAddress}
        </div>
        <div>
            <Icon icon="reply" iconFamily="fas" color={designConstants.QuorumBlue} />
            Reply To Name & Email: {props.replyToName} | {props.replyToAddress}
        </div>
    </S.SendConfirmationWrapper>
)

SendConfirmation.propTypes = {
    fromAddress: PropTypes.string.isRequired,
    fromName: PropTypes.string.isRequired,
    isScheduled: PropTypes.bool.isRequired,
    replyToAddress: PropTypes.string.isRequired,
    replyToName: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    scheduledSendMoment: PropTypes.object,
    subject: PropTypes.string.isRequired,
}

export default connect(sendConfirmationConnection, null)(SendConfirmation)
